import { INSTITUTION_SLUG } from 'constants/index'
import { Summary, SummaryTexts } from 'contexts/SummaryManager/types'

type KeyString = {
  [key: string]: [string, string]
}

function getSummaryArrayTextsByInstitutionSlug(value: KeyString): [string, string] {
  if (value[INSTITUTION_SLUG]) return value[INSTITUTION_SLUG]
  return value.default
}

function formatSummaryTextByBeenSingleOrPlural(key: string, index: number): string {
  if (index === 0) return `${key}Single`
  return `${key}Plural`
}

function setSummaryTextAndYourCapitalizedVersionOnObject(key: string, text: string): SummaryTexts {
  const object: SummaryTexts = {}
  object[key] = text
  object[`${key}Capitalize`] = `${text.substring(0, 1).toUpperCase()}${text.substring(1, text.length)}`
  return object
}

function setSummaryTextOnObject(key: string, text: string): SummaryTexts {
  const object: SummaryTexts = {}
  object[key] = text
  return object
}

export function formatSummaryTextsBySummaryObject(summary: Summary): SummaryTexts {
  let correctTextsOnSummary: any = {}

  for (const key in summary) {
    const summaryArray: KeyString = summary[key]
    const summaryArrayText: [string, string] = getSummaryArrayTextsByInstitutionSlug(summaryArray)
    summaryArrayText.forEach((text, index) => {
      const summaryKey = formatSummaryTextByBeenSingleOrPlural(key, index)
      let newSummaryTextsItem = {}
      if (summaryArrayText.length === 2) {
        newSummaryTextsItem = setSummaryTextAndYourCapitalizedVersionOnObject(summaryKey, text)
      } else {
        newSummaryTextsItem = setSummaryTextOnObject(key, text)
      }

      correctTextsOnSummary = { ...correctTextsOnSummary, ...newSummaryTextsItem }
    })
  }

  return correctTextsOnSummary as SummaryTexts
}
